import { useCallback, useEffect, useState } from 'react';
import { BalancePortalUrlApiResponse } from 'src/types/Balance';
import { fetchBalancePortalUrl as fetchBalancePortalUrlFromApi } from 'src/components/selfService/common/Balance/api/fetchBalancePortalUrl';

export type UseFetchBalancePortalUrlReturnType = {
  isLoading: boolean;
  hasError: boolean;
  balancePortalUrl: BalancePortalUrlApiResponse | null;
  fetchBalancePortalUrl: () => Promise<void>;
};

export const useFetchBalancePortalUrl = (
  externalBalanceBuyerId: string | null
): UseFetchBalancePortalUrlReturnType => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [balancePortalUrl, setBalancePortalUrl] =
    useState<BalancePortalUrlApiResponse | null>(null);

  const fetchBalancePortalUrl = useCallback(async (): Promise<void> => {
    if (!externalBalanceBuyerId) {
      return;
    }

    try {
      setIsLoading(true);
      setHasError(false);

      const response = await fetchBalancePortalUrlFromApi(
        externalBalanceBuyerId
      );
      setBalancePortalUrl(response);
    } catch (error) {
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  }, [externalBalanceBuyerId]);

  useEffect(() => {
    fetchBalancePortalUrl();
  }, [externalBalanceBuyerId, fetchBalancePortalUrl]);

  return {
    isLoading,
    hasError,
    balancePortalUrl,
    fetchBalancePortalUrl,
  };
};
